import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { registerAuth0TokenGetter } from "../utils/auth0Utils";

/**
 * Bridges the Auth0 React SDK with the non-React parts of the app (axios, services).
 * Registers the SDK helpers so shared utilities can fetch tokens or trigger logout.
 */
const AuthTokenBridge = ({ children }) => {
  const { getAccessTokenSilently, logout } = useAuth0();

  useEffect(() => {
    registerAuth0TokenGetter(getAccessTokenSilently, logout);
  }, [getAccessTokenSilently, logout]);

  return children;
};

export default AuthTokenBridge;


